/* src/app/builder-screen-beta/inspector/context-fields-modal.component.scss */
.context-fields-modal .modal-header {
  margin-bottom: 16px;
}
.context-fields-modal .modal-header h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
}
.context-fields-modal .modal-header .help-text {
  color: #8c8c8c;
  font-size: 12px;
  margin: 0;
}
.context-fields-modal .modal-content .quick-actions {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}
.context-fields-modal .modal-content .quick-actions .selection-count {
  margin-left: auto;
  color: #8c8c8c;
  font-size: 12px;
}
.context-fields-modal .modal-content .fields-list {
  max-height: 400px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.context-fields-modal .modal-content .fields-list .field-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background 0.2s;
  margin-left: 0 !important;
  margin-inline-start: 0 !important;
}
.context-fields-modal .modal-content .fields-list .field-item:hover {
  background: #fafafa;
}
.context-fields-modal .modal-content .fields-list .field-item .field-label {
  font-size: 13px;
  font-weight: 500;
}
.context-fields-modal .modal-content .fields-list .field-item .field-type-tag {
  font-size: 10px;
  line-height: 16px;
  padding: 0 4px;
  margin-left: 6px;
  border-radius: 3px;
}
.context-fields-modal .modal-content .fields-list .field-item .field-path {
  color: #8c8c8c;
  font-size: 11px;
  margin-left: 8px;
}
.context-fields-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
/*# sourceMappingURL=context-fields-modal.component.css.map */
